import { FC } from "react";
import compact from "lodash/compact";
import { ClickableCard } from "@/components/Card";
import Typography from "@/components/Typography";
import { TopLevelDialogNames } from "@/components/TopLevelDialogs";
import { Skeleton } from "@/components/Loader";
import { useDialog, useResponsive, useRoutes, useTrackers } from "@/hooks";
import { Group, useGroupQuery } from "@/fetch/social";
import { AvatarGroup } from "@/components/Avatar";
import { CloseIcon, ChevronIcon } from "@/components/Icon";
import styles from "./GroupCard.module.scss";

const GroupCard: FC<{ onClose?: () => void }> = ({ onClose }) => {
  const { data: group, isLoading: isLoading } = useGroupQuery();
  const { openTopLevelDialog } = useDialog();
  const { track } = useTrackers();
  const membersProfilePicPath = compact(
    group?.recent_members?.map((member) => member?.s3_profile_pic)
  ).slice(0, 5);
  //   const totalMembers = group?.total_members
  //     ? group?.total_members - membersProfilePicPath.length
  //     : 0;

  const totalMembers = 700;

  const description = group?.description;

  const handleOpenGroupMembersDialog = () => {
    track("Travellers List Opened", { eventId: "travellers-list-opened" });
    openTopLevelDialog(TopLevelDialogNames.GroupMembers);
  };

  const tempImgUrls = [
    "https://res.cloudinary.com/gwatco/image/upload/dpr_auto/c_fill,h_48,w_48/f_auto/v1719779400/website/static/header-social-proof/1",
    "https://res.cloudinary.com/gwatco/image/upload/dpr_auto/c_fill,h_48,w_48/f_auto/v1719779400/website/static/header-social-proof/4",
    "https://res.cloudinary.com/gwatco/image/upload/dpr_auto/c_fill,h_48,w_48/f_auto/v1719779400/website/static/header-social-proof/2",
    "https://res.cloudinary.com/gwatco/image/upload/dpr_auto/c_fill,h_48,w_48/f_auto/v1719779400/website/static/header-social-proof/3",
  ];

  const handleCloseCard = (event: React.MouseEvent) => {
    event.stopPropagation();
    onClose?.();
  };

  return (
    <ClickableCard
      onClick={handleOpenGroupMembersDialog}
      className={styles.container}
    >
      {isLoading ? (
        <>
          <div className={styles.groupAvatarLoader}>
            {Array(4)
              .fill(null)
              .map((_, index) => (
                <Skeleton
                  key={index}
                  variant="circular"
                  height="36px"
                  width="36px"
                />
              ))}
          </div>

          <>
            <Skeleton width="100%" />
            <Skeleton width="70%" />
          </>
        </>
      ) : (
        <>
          <Typography variant="h6">
            Strangers today.
            <br />
            Travel friends tomorrow.
          </Typography>
          <CloseIcon className={styles.closeIcon} onClick={handleCloseCard} />
          <div className={styles.avatarContainer}>
            <AvatarGroup
              max={6}
              cloudinaryPaths={
                membersProfilePicPath.length < 3 ? [] : membersProfilePicPath
              }
              imageUrls={
                membersProfilePicPath.length < 3 ? tempImgUrls : undefined
              }
              className={styles.avatars}
              AvatarProps={{ size: "m" }}
            />
            {Boolean(totalMembers) && (
              <Typography
                className={styles.countNumber}
                variant="caption"
                color="primary"
              >
                +{totalMembers}
              </Typography>
            )}
            <ChevronIcon className={styles.chevronIcon} />
          </div>
          <Typography variant="body2" color="text.secondary">
            Your exclusive group for all Global Travellers in this region of the
            world on any of our trips. Introduce your self, reach out to say Hi,
            and organise in-person meet-ups.
          </Typography>
        </>
      )}
    </ClickableCard>
  );
};

export default GroupCard;
